import Newsletter from './components/newsletter';

$(document).ready(() => {
    let newsletter = new Newsletter();
});
